import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { ContextualTooltip, StandardTooltip } from './Tooltip.components';
import { Button } from '../Button/Button';
import { Typography, ClickAwayListener, Box, Fade } from '@mui/material';
import { IInfo } from '../Iconography';
import { HelixPalette, HelixStyles } from '../../helix';
/**
 * Simple tooltip.
 */
export const Tooltip = ({ children, enterDelay, leaveDelay, placement = 'bottom', title, contextual = false, buttonLabel, onClick, contextualIcon = _jsx(IInfo, {}), }) => {
    //State
    const [open, setOpen] = useState(false);
    const [arrowRef, setArrowRef] = React.useState(null);
    //Refs
    const buttonRef = useRef(null);
    const id = open ? 'contextual-tooltip' : undefined;
    const handleOnClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpen(!open);
    };
    const handleOnClickAway = (e) => {
        if (open) {
            e.preventDefault();
            e.stopPropagation();
            setOpen(false);
        }
    };
    if (contextual) {
        return (_jsx(ClickAwayListener, Object.assign({ onClickAway: handleOnClickAway }, { children: _jsxs("div", { children: [_jsx(Button, { dataId: "tooltip-trigger", "aria-describedby": id, ref: buttonRef, onClick: handleOnClick, type: "universal", leftIcon: contextualIcon, size: "small" }), _jsx(ContextualTooltip, Object.assign({ id: id, anchorEl: buttonRef.current, open: open, placement: placement, disablePortal: true, transition: true, modifiers: [
                            {
                                name: 'arrow',
                                enabled: true,
                                options: {
                                    element: arrowRef,
                                    padding: 5,
                                },
                            },
                            {
                                name: 'offset',
                                options: {
                                    offset: [0, 8],
                                },
                            },
                            {
                                name: 'preventOverflow',
                                enabled: true,
                            },
                        ] }, { children: ({ TransitionProps }) => (_jsx(Fade, Object.assign({}, TransitionProps, { timeout: { enter: enterDelay, exit: leaveDelay } }, { children: _jsxs(Box, Object.assign({ sx: { backgroundColor: HelixPalette.neutral90, borderRadius: '0.4rem', padding: '0.25rem 0.5rem' } }, { children: [_jsx(Typography, Object.assign({}, HelixStyles.style_07, { color: HelixPalette.white, style: { whiteSpace: 'pre-line' } }, { children: title })), buttonLabel && onClick && (_jsx(Button, { dataId: "tooltip-action", label: buttonLabel, onClick: onClick, type: "universal", variant: "white", size: "small", style: { marginTop: '8px' } })), _jsx(Box, { className: "arrow", ref: setArrowRef })] })) }))) }))] }) })));
    }
    return (_jsx(StandardTooltip, Object.assign({ enterDelay: enterDelay, leaveDelay: leaveDelay, placement: placement, title: title }, { children: children })));
};
export default Tooltip;
